export default class AuthenticationData {

  //Constructor
  constructor() {
    /*this._repoId = null;
     this._password = "sa";
     this._cookie = null;
     this._serverUrl = "http://localhost:8880";
     this._rememberMe = true;
     this._username = "sa";
     this._repoId = null;*/
    this._webminUrl = '';
    this.useCookieForLogin = false;
  }

  static parse(str) {
    const o = JSON.parse(str);
    const authData = new AuthenticationData();
    Object.assign(authData, o);
    return authData;
  }

  get webminUrl() {
    return this._webminUrl;
  }

  set webminUrl(value) {
    this._webminUrl = value;
  }

  //Getter for repoId
  get repoId() {
    return this._repoId;
  }

  //Setter for repoId
  set repoId(repoId) {
    this._repoId = repoId;
  }

  //Getter for password
  get password() {
    return this._password;
  }

  //Setter for password
  set password(password) {
    this._password = password;
  }

  //Getter for cookie
  get cookie() {
    return this._cookie;
  }

  //Setter for cookie
  set cookie(cookie) {
    this._cookie = cookie;
  }

  //Getter for serverUrl
  get serverUrl() {
    return this._serverUrl;
  }

  //Setter for serverUrl
  set serverUrl(serverUrl) {
    this._serverUrl = serverUrl;
  }

  //Getter for rememberMe
  get rememberMe() {
    return this._rememberMe;
  }

  //Setter for rememberMe
  set rememberMe(rememberMe) {
    this._rememberMe = rememberMe;
  }

  //Getter for username
  get username() {
    return this._username;
  }

  //Setter for username
  set username(username) {
    this._username = username;
  }

  /**
   *
   * @param sslRvEnabled{boolean}
   */
  set sslRvEnabled(sslRvEnabled) {
    this._sslRvEnabled = sslRvEnabled;
  }

  /**
   *
   * @return {boolean}
   */
  get sslRvEnabled() {
    return this._sslRvEnabled;
  }

  /**
   *
   * @param previewServerUrlsList{Array.<string>}
   */
  set previewServerUrlsList(previewServerUrlsList) {
    this._previewServerUrlsList = previewServerUrlsList;
  }

  /**
   *
   * @return {Array.<string>}
   */
  get previewServerUrlsList() {
    return this._previewServerUrlsList;
  }

  /**
   *
   * @param previewServerSSLUrlsList{Array.<string>}
   */
  set previewServerSSLUrlsList(previewServerSSLUrlsList) {
    this._previewServerSSLUrlsList = previewServerSSLUrlsList;
  }

  /**
   *
   * @return {Array.<string>}
   */
  get previewServerSSLUrlsList() {
    return this._previewServerSSLUrlsList;
  }

  /**
   *
   * @param previewServerUrl{string}
   */
  set previewServerUrl(previewServerUrl) {
    this._previewServerUrl = previewServerUrl;
  }

  /**
   *
   * @return {string}
   */
  get previewServerUrl() {
    return this._previewServerUrl;
  }

  get serverRealm() {
    return this._serverRealm;
  }

  set serverRealm(serverRealm) {
    this._serverRealm = serverRealm;
  }

  /**
   *
   * @return {string}
   */

  get reviewServerUrl(): string {
    return this._reviewServerUrl;
  }

  /**
   *
   * @param reviewServerUrl{string}
   */

  set reviewServerUrl(reviewServerUrl: string) {
    this._reviewServerUrl = reviewServerUrl;
  }

  /**
   *
   * @return {boolean|*}
   */


  get userHasAdminPerm(): boolean {
    return this._hasAdminRights;
  }

  set userHasAdminPerm(hasAdminRights: boolean) {
    this._hasAdminRights = hasAdminRights;
  }

  get isSuperAdmin(): boolean {
    return this._isSuperAdmin;
  }

  set isSuperAdmin(isSuperAdmin: boolean) {
    return this._isSuperAdmin = isSuperAdmin;
  }

  set externalUserId(externalUserId: string) {
    this._externalUserId = externalUserId;
  }

  get externalUserId() {
    return this._externalUserId;
  }

  isMe(id): boolean {
    return id === this.username || id === this.externalUserId;
  }
}